/**
 * Возвращает список объектов с уникальными значениями
 * Значение вычисляется с помощью фунции fn
 */
export function uniqByFn<T>(list: T[], fn: (T) => number | string): T[] {
  const _index = [];
  return list.reduce((_list, item) => {
    const _t = fn(item);
    if (!_index.includes(_t)) {
      _list.push(item);
      _index.push(_t);
    }
    return _list;
  }, []);
}

/**
 * Возвращает список уникальных дат с точностью до миллисекунды
 */
export function uniqDates(list: Date[]): Date[] {
  return uniqByFn(list, (d: Date) => d.getTime());
}
